import { Stack } from "@mui/material";
import { LoadingButton as Button } from "@mui/lab";
import PatientForm from "../../utils/patient/form";
import SurnameInput from "../../utils/patient/new/SurnameInput";
import { useApi } from "../../../utils/hooks";
import { useState } from "react";
import { ErrorAlert } from "../../../utils";
import _ from "lodash";

const EditPatientForm = ({ id, onSuccess, onCancel, initialValues }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const api = useApi();

  const onSubmit = (updatedPatient) => {
    setLoading(true);
    api
      .updatePatient(id, updatedPatient)
      .then((response) => {
        onSuccess(response);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <>
      <PatientForm 
        SurnameInput={SurnameInput} 
        onSubmit={onSubmit}
        initialValues={_.omit(initialValues, "user", "healthCenter")}
      >
        <Stack direction="row" spacing={2} justifyContent="flex-end" mt={4}>
          <Button 
            variant="outlined" 
            onClick={onCancel}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button 
            variant="contained" 
            type="submit"
            loading={loading}
          >
            Guardar
          </Button>
        </Stack>
      </PatientForm>
      {error && (
        <ErrorAlert
          show={!!error}
          onClose={() => setError(null)}
          message="No se pudo actualizar el paciente" 
        />
      )}
      </>
  );
};

export default EditPatientForm; 